import { client, validateClientProperty } from "./ts-rest"

export function useGetAuthData() {
  const response = client.getAuthData.useQuery({
    queryKey: [validateClientProperty("getAuthData")],
  })

  return {
    ...response,
    user: response.data?.body.user,
  }
}

export function useGetIntegrations() {
  return client.getIntegrations.useQuery({
    queryKey: [validateClientProperty("getIntegrations")],
  })
}
